import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { formatBytes } from '../../utils/formatters';
interface QuotaData {
  current: number;
  limit: number;
  percentageUsed: number;
  isExceeded: boolean;
}
interface Props {
  quotaType: 'knowledgeSpaces' | 'chatbots' | 'documents' | 'storage';
  quota: QuotaData;
  formatValue?: (value: number) => string;
}
export const QuotaWarning = ({
  quotaType,
  quota,
  formatValue = String
}: Props) => {
  if (quota.percentageUsed < 90) return null;
  const labels = {
    knowledgeSpaces: 'Knowledge Space',
    chatbots: 'Chatbot',
    documents: 'Document',
    storage: 'Storage Space'
  };
  const formatQuotaValue = (value: number) => {
    if (quotaType === 'storage') {
      return formatBytes(value);
    }
    return formatValue(value);
  };
  return <div className="bg-status-error/10 border border-status-error/30 rounded-none p-4 flex items-start gap-3 animate-in slide-in-from-top-2" data-id="element-432">
      <AlertCircleIcon size={20} className="text-status-error shrink-0 mt-0.5" data-id="element-433" />
      <div data-id="element-434">
        <p className="text-status-error font-medium" data-id="element-435">
          {labels[quotaType]} Quota Warning
        </p>
        <p className="text-sm text-status-error/80 mt-1" data-id="element-436">
          You have used {formatQuotaValue(quota.current)} of{' '}
          {formatQuotaValue(quota.limit)} available{' '}
          {labels[quotaType].toLowerCase()}
          {quotaType !== 'storage' && quota.limit > 1 && 's'}. Contact support
          to increase your limit.
        </p>
      </div>
    </div>;
};